export enum WidgetType {
  Co2Average = "Co2Average",
  BlockchainEnergyCost = "BlockchainEnergyCost",
  SensorMap = "SensorMap",
  Co2Evolution = "Co2Evolution",
  Co2RelativeAverage = "Co2RelativeAverage",
}
